
import request from "@/config/yqyaxios";

export default {

  collectFee: {
    formData: (projectCode, liveCode) => {
      return request({
        method: "GET",
        url: "collectFee/formData?projectCode=" + projectCode + "&liveCode=" + liveCode,
        auth: true,
      });
    },

    add: (data) => {
      return request({
        method: "POST",
        url: "collectFee/add",
        auth: true,
        data: data
      });
    },



  },

  appPage: {
    getAppPageFunMap: (data) => {
      return request({
        method: "POST",
        url: "appPage/getAppPageFunMap",
        auth: true,
        data: data
      });
    },
  },
  member: {

    registerForm: () => {
      return request({
        method: "GET",
        url: "member/registerForm",
        auth: true
      });
    },

    sendSmsCode: (mobile) => {
      return request({
        method: "POST",
        url: "member/sendSmsCode?mobile=" + mobile,
        auth: true,
      });
    },


    saveRegister: (data) => {
      return request({
        method: "POST",
        url: "member/saveRegister",
        auth: true,
        data: data,
      });
    },



  },
};
